import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { APPIndicatorForm } from './APPIndicatorForm';
import { ViewContainer } from "../../View";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();


const projectRef = React.createRef();

class APPIndicator extends Component {

    state = {
        model: this.props.location.state.IsAdd ? {
            ProjectName: this.props.location.state.projectDescription,
            ProjectID: this.props.location.state.projectIDDescription,
            ProgrammeStructure: this.props.location.state.selection ? this.props.location.state.selection.ProgrammeStructure : null
        } : {},
        importRecordID: !utils.isNull(this.props.location.state.selection) ? this.props.location.state.selection.Id : this.props.location.state.projectID,
        PType: this.props.location.state.PType,
        FinancialYearDesc: !utils.isNull(this.props.location.state.FinancialYearDesc) ? this.props.location.state.FinancialYearDesc : null,
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Go back to the APP Maintenance search module', icon: 'CloseIcon' },

                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.onMenuSpecificPermissionItem('/APPMaintenanceSearch').Edit }
                    ]
                }
            ]
        }
    };

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ ProjectDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        }
        else if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/APPMaintenanceSearch',
                state: {
                }
            })
        }
    }

    close() {
        this.props.history.push('/APPMaintenanceSearch');
    }

    successCallback = (response) => {
        console.log(response)
        this.setState({ message: "APP Indicator updated successfully", messageStyle: "SUCCESS", importRecordID: response.EntityId });
    }

    save() {
        let formValue = projectRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {

            if (!utils.isNull(this.state.importRecordID)) {
                formValue.id = this.state.importRecordID;
            }
            if (!utils.isNull(this.state.FinancialYearDesc)) {
                formValue.FinancialYearDescription = this.state.FinancialYearDesc;
            }
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/APPMaintenance/UpdateAPPIndicator", (response) => {
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    render() {

        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {"APP Indicator Details"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    enabled={true} config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "64vh", maxHeight: "64vh" }}>
                                    <APPIndicatorForm ref={projectRef} id={this.props.location.state.IsAdd ? null : this.state.importRecordID} data={this.state.model} PType={this.state.PType}
                                        valueChangeHandler={(values) => this.handleFormValueChange(values)} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(APPIndicator));
